import { axiosInstance } from "@/api/axiosInstance";
import {
  AddressAddonApi,
  AddressAddonApiAddonsViewsNinjaAddressCancelRenewalForAddressRequest,
  AddressAddonApiAddonsViewsNinjaAddressListAddressForBusinessRequest,
} from "@/api/client";
import { BASE_API } from "@/helpers/constants";

const api = new AddressAddonApi(undefined, BASE_API, axiosInstance);

export const getAllAddressForBusiness = async (
  payload: AddressAddonApiAddonsViewsNinjaAddressListAddressForBusinessRequest
) => {
  return api.addonsViewsNinjaAddressListAddressForBusiness.bind(api)(payload);
};

export const cancelRenewalForAddress = async (
  payload: AddressAddonApiAddonsViewsNinjaAddressCancelRenewalForAddressRequest
) => {
  return api.addonsViewsNinjaAddressCancelRenewalForAddress.bind(api)(payload);
};
